import MinMessage from '../../components/molecules/messages/MinMessage.vue'
export default {
  components: { MinMessage }
}
